//JS for changing the display depending on variant type (show postcode search for mobile and show book now or add to cart) 
$(document).on('change', 'input[type="radio"][name*="Collection Method-1"]', function () {
  var collMethod = $(this).val();
  const submitButtonSpan = document.querySelector('product-form [type="submit"] span');
  const specialTitles = [
    "Blood taken by a professional in-clinic",
    "Book a home nurse visit to have your blood sample taken",
    "In clinic appointment"
  ];
  const specialTitlesClinic = [
    "Blood taken by a professional in-clinic",
    "In clinic appointment"
  ];
  const specialTitlesMobile = [
    "Book a home nurse visit to have your blood sample taken"
  ];

  const titlesHomeTests = [
    "Blood taken at home via finger-prick kit",
    "Organise my own blood collection",
    "Collect Sample at Home",
    "1 Body Part",
    "2 Body Parts",
    "Full Body MRI Scan – Gold",
    "Full Body MRI Scan – Gold with prostate screening",
    "Full Body MRI Scan – Platinum",
    "Full Body MRI Scan – Platinum with prostate screening",
  ];


  setTimeout(() => {
    if (specialTitles.includes(collMethod)) {
      submitButtonSpan.textContent = "Book now";
      jQuery(".shopify-payment-button").hide();
    } else {
      submitButtonSpan.textContent = window.variantStrings?.addToCart || "Add to cart";
      if (titlesHomeTests.includes(collMethod)) { 
        jQuery(".shopify-payment-button").hide();
      } else {
        jQuery(".shopify-payment-button").show();
      }
    }
    if (specialTitlesMobile.includes(collMethod)) {
      jQuery("#mobileBookingPostcodeCheck").removeClass('disp_none');
    } else {
      jQuery("#mobileBookingPostcodeCheck").addClass('disp_none');
    }
  }, 400);
  
});

const metafieldsEl = document.getElementById('product-metafields');
if (metafieldsEl) {
    const upsells = JSON.parse(metafieldsEl.dataset.upsells);

}


// JS for redirecting to the right booking page for mobile and in clinic booking
$('product-form [type="submit"]').on('click', function(e) {
  
  const specialTitlesClinic = [
    "Blood taken by a professional in-clinic",
    "In clinic appointment"
  ];
  const specialTitlesMobile = [
    "Book a home nurse visit to have your blood sample taken"
  ];
  const titlesHomeTests = [
    "Blood taken at home via finger-prick kit",
    "Organise my own blood collection",
    "Collect Sample at Home",
    "1 Body Part",
    "2 Body Parts",
    "Full Body MRI Scan – Gold",
    "Full Body MRI Scan – Gold with prostate screening",
    "Full Body MRI Scan – Platinum",
    "Full Body MRI Scan – Platinum with prostate screening",
  ];

  var collectionMethod = $(
  'input[type="radio"][name*="Collection Method-1"]:checked, ' +
  'input[type="radio"][name*="Options-1"]:checked, ' +
  'input[type="radio"][name*="Recording-1"]:checked'
  ).val();

  const selectedRadio = $('input[type="radio"][name*="Collection Method-1"]:checked');
  const variantId = selectedRadio.closest('label').find('.var_price').data('nid');
  const variantSku = selectedRadio.closest('label').find('.var_price').data('sku');
  const productHandle = $('#product-handle').val();
  const eurofins_code = $('#eurofins_code').val();
  const productTitle = $('#product-title').val();
  const aptId = $('#aptId').val();

  if (specialTitlesClinic.includes(collectionMethod)) {
    e.preventDefault();  // stops default form submission
    e.stopPropagation(); // stops bubbling to Shopify’s handlers

    // Save to sessionStorage
    sessionStorage.setItem('variant_id', variantId);
    sessionStorage.setItem('variant_sku', variantSku);
    sessionStorage.setItem('aptId', aptId);
    sessionStorage.setItem('product_handle', productHandle);
    sessionStorage.setItem('eurofinsCode', eurofins_code);
    sessionStorage.setItem('product_title', productTitle);
    if (metafieldsEl) {
      const upsells = metafieldsEl.dataset.upsells;
      console.log(JSON.parse(upsells));
      sessionStorage.setItem('upsells', upsells);
    }

    window.location.href = '/pages/find-clinic';

  } else if (specialTitlesMobile.includes(collectionMethod)) { 
    e.preventDefault();  // stops default form submission
    e.stopPropagation(); // stops bubbling to Shopify’s handlers
    const postCode = $('#preSearchFormobile_venous').val();

    // Save to sessionStorage
    sessionStorage.setItem('variant_id', variantId);
    sessionStorage.setItem('product_handle', productHandle);
    sessionStorage.setItem('aptId', aptId);
    sessionStorage.setItem('eurofinsCode', eurofins_code);
    sessionStorage.setItem('product_title', productTitle);
    sessionStorage.setItem('postCode', postCode);
    sessionStorage.setItem('variant_sku', variantSku);
    if (metafieldsEl) {
      const upsells = metafieldsEl.dataset.upsells;
      console.log(JSON.parse(upsells));
      sessionStorage.setItem('upsells', upsells);
    }

    window.location.href = '/pages/check-mobile-availability';

  } else if (titlesHomeTests.includes(collectionMethod)) { 

      e.preventDefault();  // stops default form submission
      e.stopPropagation(); // stops bubbling to Shopify’s handlers
      const modal = document.getElementById('thankYouModal');
      const backdrop = document.getElementById('modalBackdrop');
      modal.style.display = 'block';
      backdrop.style.display = 'block';
      return;

  }
});

window.closeThankYouModal = function() {
  const modal = document.getElementById('thankYouModal');
  const backdrop = document.getElementById('modalBackdrop');
  modal.style.display = 'none';
  backdrop.style.display = 'none';
};

window.continueToAddToBasket = async function(e) {
  const backdrop = document.getElementById('modalBackdrop');

  const firstNameInput = document.getElementById('modal-firstName');
  const lastNameInput = document.getElementById('modal-lastName');
  const dobInput = document.getElementById('modal-dob');
  const genderInputs = document.querySelectorAll('input[name="modal-gender"]');
  let selectedGender = '';
  
  genderInputs.forEach(function(input) {
    if (input.checked) {
      selectedGender = input.value;
    }
  });

  if (!firstNameInput.value) {
    alert('Please enter the patient\'s first name before continuing.');
    return;
  }
  if (!lastNameInput.value) {
    alert('Please enter the patient\'s last name before continuing.');
    return;
  }
  if (!dobInput.value) {
    alert('Please enter the patient\'s date of birth before continuing.');
    return;
  }

  if (!selectedGender) {
    alert('Please select the patient\'s gender before continuing.');
    return;
  }

  const sectionEl = document.querySelector('[data-section-id]');
  const sectionId = sectionEl?.dataset.sectionId || null;
  const productSubmitButtonId = "ProductSubmitButton-" + sectionId;
  console.log('productSubmitButtonId:', productSubmitButtonId);

  // Create hidden inputs to pass the postCode and Clinic as product properties
  addPropertiesToForm(firstNameInput.value,lastNameInput.value,dobInput.value, selectedGender);  

  var selectedVariantsScript = document.querySelectorAll('[data-selected-variant]'); 
  var selectedVariants = JSON.parse(selectedVariantsScript[0].textContent);
  var collectionMethod = selectedVariants.option1;

  closeThankYouModal();


  document.getElementById(productSubmitButtonId).closest('form').submit();
};

function addPropertiesToForm(firstName, lastName, dob, gender) {
  const existingInputs = document.querySelectorAll('input[name^="properties["]');
  existingInputs.forEach(input => input.remove());

  const form = document.querySelector('form[data-type="add-to-cart-form"]');
  const hiddenFirstNameInput = document.createElement('input');
  hiddenFirstNameInput.type = 'hidden';
  hiddenFirstNameInput.name = 'properties[First Name]';
  hiddenFirstNameInput.value = firstName;
  form.appendChild(hiddenFirstNameInput);

  const hiddenlastNameInput = document.createElement('input');
  hiddenlastNameInput.type = 'hidden';
  hiddenlastNameInput.name = 'properties[Last Name]';
  hiddenlastNameInput.value = lastName;
  form.appendChild(hiddenlastNameInput);
  
  const hiddenDobInput = document.createElement('input');
  hiddenDobInput.type = 'hidden';
  hiddenDobInput.name = 'properties[Date of Birth]';
  hiddenDobInput.value = dob.split('-').reverse().join('/');
  form.appendChild(hiddenDobInput);

  const hiddenGenderInput = document.createElement('input');
  hiddenGenderInput.type = 'hidden';
  hiddenGenderInput.name = 'properties[Gender]';
  hiddenGenderInput.value = gender;
  form.appendChild(hiddenGenderInput);

  const productHandle = $('#product-handle').val();
  const eurofins_code = $('#eurofins_code').val();
  
  if (productHandle && productHandle != 'undefined') {
    const hiddenProductIdInput = document.createElement('input');
    hiddenProductIdInput.type = 'hidden';
    hiddenProductIdInput.name = 'properties[product_id]';
    hiddenProductIdInput.value = productHandle;
    form.appendChild(hiddenProductIdInput);
  }
  
  if (eurofins_code && eurofins_code != 'undefined') {
    const hiddenEurofinsCodeInput = document.createElement('input');
    hiddenEurofinsCodeInput.type = 'hidden';
    hiddenEurofinsCodeInput.name = 'properties[product_code]';
    hiddenEurofinsCodeInput.value = eurofins_code;
    form.appendChild(hiddenEurofinsCodeInput);
  }

}

document.getElementById('modalBackdrop').addEventListener('click', function(event) {
  
  if (event.target === this) {
    closeThankYouModal();
  }
});

document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape' && document.getElementById('thankYouModal').style.display === 'block') {
    closeThankYouModal();
  }
});

const dobInput = document.getElementById('modal-dob');
if (dobInput) {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  dobInput.max = `${yyyy}-${mm}-${dd}`;
}

//JS for calling postcode search
window.addEventListener('load', function () {
  const input = document.getElementById('preSearchFormobile_venous');
  if (input) {
    input.addEventListener('keypress', function (e) {
      console.log('keypress fired');
      if (e.key === 'Enter' || e.keyCode === 13) {
        const id = e.target?.id;
        if (id) {
          console.log('calling search for:', id);
          preFindServiceProvidersPostcode(id);
          e.preventDefault();
        }
      }
    });
  }
});


function preFindServiceProvidersPostcode(target_id, requirement) {
  var postcode_box = document.getElementById(target_id);
  if (postcode_box.value == '') {
    alert('Please enter a value post code');
    return;
  }

  var data = {
    'postcode': postcode_box.value,
  };
  document.getElementById('postcode_locations_search_mob_result').innerHTML = '<div class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>';
  
  jQuery.ajax({
    url: "https://api.gbc.health/api/v2/shopify-get-mobile-clinics", 
    type: 'GET',
    data: data,
    success: function (response) {
      var result_block = document.getElementById('postcode_locations_search_mob_result');
      result_block.innerHTML = `<div class="d-flex pt-3"><div class="dashicons dashicons-success text-success mx-1"></div><div>` + response.message + `</div></div>`;               
    },
    error: function (xhr) {
      var result_block = document.getElementById('postcode_locations_search_mob_result');
      var message = "An error occurred";

      if (xhr.responseJSON && xhr.responseJSON.message) {
        message = xhr.responseJSON.message; // safest way
      } else if (xhr.responseText) {
        try {
          var parsed = JSON.parse(xhr.responseText);
          if (parsed.message) {
            message = parsed.message;
          }
        } catch (e) {}
      }

      result_block.innerHTML = `<div class="d-flex pt-3">
          <div class="dashicons dashicons-no text-danger mx-1"></div>
          <div>${message}</div>
        </div>`;
    },
  });
}

// JS for women blood product
$(document).on('change', 'input[type="radio"][name*="subscription_picker"]', function () {
  console.log('large radio clicked');
  $("input[name='selling_plan']").prop("checked", false);
});

$(document).on('change', 'input[type="radio"][name*="selling_plan"]', function () {
  console.log('small radio clicked');
  $("input[name='selling_plan']").not(this).prop("checked", false);
  $("input[name='subscription_picker']").prop("checked", false);
  $(this).parents('label.full_width_variant').find('input[name="subscription_picker"]').prop('checked', true);
});

$('a.var_link').on('click', function(){
  var div_id = $(this).attr('data-attr');
  $('div[data-rel="'+div_id+'"]').removeClass('hidden');
});

